import React, { useRef, useState } from 'react';

import { motion } from "framer-motion"
import './Button.css';
import Card from '../Card/Card';
import CodeSnippet from '../CodeSnippet/CodeSnippet';
import { Copy } from 'lucide-react';
const LeftArrow = () => <>&lt;</>;
const RightArrow = () => <>&gt;</>;
const HtmlText = ({ text }) => <>{text}</>;
const ClassTitle = ({ className }) => <>{className}</>;

const Buttons = () => {

  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };

  return (
    <>
      <div className="Button">
        <div className="carve-button-group">
          <button className="carve-button-main">button main</button>
          <button className="carve-button-vice">button vice</button>
          <button className="carve-button-pill carve-button-main">button main button pill</button>
          <button className="carve-button-stroke stroke-main">button stroke</button>
          <button className="carve-button-stroke carve-button-pill stroke-main">button stroke button pill</button>
          <button className="button carve-button-fab" aria-label="fab-button">&#43;</button>
        </div>
      </div>
      <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

        <div className='snippet' ref={snippetContainerRef}>
          <CodeSnippet
            LeftArrow={<LeftArrow />}
            RightArrow={<RightArrow />}
            ClassTitle={<ClassTitle className="carve-button-main" />}
            HtmlText={<HtmlText text="button main" />}
          />
          <CodeSnippet
            LeftArrow={<LeftArrow />}
            RightArrow={<RightArrow />}
            ClassTitle={<ClassTitle className="carve-button-main carve-button-pill" />}
            HtmlText={<HtmlText text="button main button pill" />}
          />
          <CodeSnippet
            LeftArrow={<LeftArrow />}
            RightArrow={<RightArrow />}
            ClassTitle={<ClassTitle className="carve-button-stroke" />}
            HtmlText={<HtmlText text="button stroke" />}
          />
          <CodeSnippet
            LeftArrow={<LeftArrow />}
            RightArrow={<RightArrow />}
            ClassTitle={<ClassTitle className="carve-button-stroke carve-button-pill" />}
            HtmlText={<HtmlText text="button stroke carve-button-pill" />}
          />
          <CodeSnippet
            LeftArrow={<LeftArrow />}
            RightArrow={<RightArrow />}
            ClassTitle={<ClassTitle className="carve-button-vice" />}
            HtmlText={<HtmlText text="carve-button-vice" />}
          />
          <CodeSnippet
            LeftArrow={<LeftArrow />}
            RightArrow={<RightArrow />}
            ClassTitle={<ClassTitle className="carve-button-fab" />}
            HtmlText={<HtmlText text="carve-button-fab" />}
          />
        </div>
        <button aria-label="Copy Button" onClick={copySnippet}>
          <Copy />
        </button>

      </div>
    </>
  )
}
const Button = () => {
  const generateCard = (key) => (
    <motion.div
      key={key}
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Card
        CardTitle={<HtmlText text="Buttons" />}
        CardBody={<Buttons />}
      />
    </motion.div>
  );

  const cards = Array.from({ length: 1 }, (_, index) => generateCard(index));

  return <>{cards}</>;
};


Button.propTypes = {};

export default Button;
